import { ApolloLink, HttpLink, from } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

import { createNewRelicAttributeLink } from '@consumer/graphql'

import { getFirebaseAuthorizationHeader } from '../firebase'
import { logError } from '../monitorClient'

// From https://stackoverflow.com/questions/47211778/cleaning-unwanted-fields-from-graphql-responses/51380645#51380645
const omitTypename = (key: string, value: unknown) => (key === '__typename' ? undefined : value)
export const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename)
  }
  return forward(operation).map(data => {
    return data
  })
})

export const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    graphQLErrors
      // "Not Authorized" errors are expected for anonymous tracking sessions: the esus Lambda
      // authorizer correctly denies PII address fields and Order.consumerId when the request
      // carries only an AppCheck token (no Firebase user ID token). errorPolicy:'all' already
      // handles these gracefully at the query level — reporting them to NR as JavaScriptErrors
      // would flood the error rate and trigger false alerts. See CBP-4505.
      .filter(({ message }) => !message.startsWith('Not Authorized'))
      .forEach(({ message, path }) =>
        // path is an array — join to a dot-separated string so it reaches NR as a primitive.
        // 'consumer.operation' aligns with the shared NR_ATTR.OPERATION key from @consumer/graphql.
        logError(`GraphQL error: ${message}`, {
          path: path?.join('.'),
          'consumer.operation': operation.operationName,
        })
      )
  }
  if (networkError) {
    logError(`Network error: ${networkError.message}`, {
      'consumer.operation': operation.operationName,
    })
  }
})

export const authMiddleware = setContext(async (_, { headers }) => {
  return {
    headers: {
      ...headers,
      serviceName: 'CWA',
      authorization: await getFirebaseAuthorizationHeader(),
    },
  }
})

const httpLink = new HttpLink({
  uri: import.meta.env.REACT_APP_API_GRAPHQL_URL,
})

const newRelicLink = createNewRelicAttributeLink('web')

export const link = from([newRelicLink, cleanTypeName, authMiddleware, errorLink, httpLink])
